const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyregistration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-61"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.77,
    y: 391.92,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.31,
    width: 49.86,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.24,
    y: 401.21,
    width: 29.53,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 399.53,
    width: 21.6,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.96,
    y: 399.53,
    width: 38.37,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.54,
    y: 389.21,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.87,
    y: 82.48,
    width: 109.31,
    height: 155.68,
    transform: "translate(485.04 320.65) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.69,
    y: 82.48,
    width: 109.31,
    height: 155.68,
    transform: "translate(476.68 320.65) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.51,
    y: 113.18,
    width: 141.66,
    height: 94.29,
    transform: "translate(398.66 -78.01) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.94,
    y: 158.74,
    width: 141.66,
    height: 3.16,
    transform: "translate(353.1 -32.45) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.79,
    y: 189.09,
    width: 103.1,
    height: 9.41,
    transform: "translate(476.68 387.59) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.79,
    y: 101.85,
    width: 103.1,
    height: 9.41,
    transform: "translate(476.68 213.11) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.72,
    y: 82.48,
    width: 109.31,
    height: 155.68,
    transform: "translate(218.75 320.65) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.54,
    y: 82.48,
    width: 109.31,
    height: 155.68,
    transform: "translate(210.39 320.65) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.36,
    y: 113.18,
    width: 141.66,
    height: 94.29,
    transform: "translate(265.52 55.13) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -11.2,
    y: 158.74,
    width: 141.66,
    height: 3.16,
    transform: "translate(219.95 100.7) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.65,
    y: 189.09,
    width: 103.1,
    height: 9.41,
    transform: "translate(210.39 387.59) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.65,
    y: 101.85,
    width: 103.1,
    height: 9.41,
    transform: "translate(210.39 213.11) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2,287.82c5.62-3.34,9.77-9,9.05-22-1.22-21.73-17.84-24.26-21.6-33.67a17.8,17.8,0,0,0,3.24-5.22c5.53-12.76-6.58-17.44-.41-24.38,3.73-4.2,1-9.81-3.4-12.61s-6.9-3.51-4.72-7.93c2.33-4.74-3.07-14.49-11.29-13.69-9.2.9-9.28-5.41-15.41-2.95s.95,8.67-8.17,12.2a6.81,6.81,0,0,0-4,3.45c-5.84-2.57-12.88-3-19,.87-15.09,9.5-20.68-1.31-29.12,8.23s9.14,14.11-3.54,28.08c-8.46,9.33-2.17,18.26,6.9,23.05h0c-10,.5-14.69,13.11-11.07,18.35,3.38,4.9.6,6.16-4.24,10.32s-7,11.31-1.83,15.67c8.6,7.2-5,14.94,3.82,29.21,12.52,20.16,32.25-14.54,42,20.5,1.27,4.57-.86,16.35,2.53,17.21,6.31,8.16,22.45,5.24,30.34,1.17.88-.42-.49-6.81.3-7.38a34.25,34.25,0,0,0,8.1-7.53c8.56-4.42,14.75,10.27,25.49-2.49,9-10.64-1.3-18.6,6.61-23.48,4.78-3,3.81-9.09.36-13.05s-5.6-5.34-2.25-9A6.17,6.17,0,0,0,425.2,287.82Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.28,345.66S345,382.4,373.1,382.4s28.81-36.74,28.81-36.74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.56,
    y: 277.21,
    width: 129.62,
    height: 80.75,
    transform: "translate(427.96 207.22) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.29,
    y: 239.17,
    width: 38.16,
    height: 71.88,
    transform: "translate(385.48 164.74) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.29,
    y: 280.75,
    width: 38.16,
    height: 71.88,
    transform: "translate(427.06 206.32) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.29,
    y: 322.33,
    width: 38.16,
    height: 71.88,
    transform: "translate(468.64 247.9) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.49,
    y: 260.97,
    width: 38.16,
    height: 28.27,
    transform: "translate(363.67 186.54) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.49,
    y: 302.55,
    width: 38.16,
    height: 28.27,
    transform: "translate(405.25 228.12) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.36,
    y: 320.52,
    width: 19.59,
    height: 15.24,
    transform: "translate(250.31 656.29) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.95,
    y: 320.52,
    width: 8.27,
    height: 15.24,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.72,
    y: 320.52,
    width: 19.59,
    height: 15.24,
    transform: "translate(187.03 656.29) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.31,
    y: 320.52,
    width: 8.27,
    height: 15.24,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.49,
    y: 344.13,
    width: 38.16,
    height: 28.27,
    transform: "translate(446.83 269.7) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.9,
    y: 306.63,
    width: 129.62,
    height: 21.93,
    transform: "translate(479.3 155.88) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.51,
    y: 344.69,
    width: 44.16,
    height: 32.66,
    transform: "translate(231.19 722.04) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.68,
    y: 344.69,
    width: 8.64,
    height: 32.66,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.31,
    y: 261.53,
    width: 58.37,
    height: 32.66,
    transform: "translate(216.98 555.71) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.68,
    y: 261.53,
    width: 8.64,
    height: 32.66,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.3,
    y: 277.21,
    width: 129.62,
    height: 80.75,
    transform: "translate(514.7 120.47) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.04,
    y: 239.17,
    width: 38.16,
    height: 71.88,
    transform: "translate(472.22 77.99) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.04,
    y: 280.75,
    width: 38.16,
    height: 71.88,
    transform: "translate(513.8 119.57) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.04,
    y: 322.33,
    width: 38.16,
    height: 71.88,
    transform: "translate(555.38 161.15) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.23,
    y: 260.97,
    width: 38.16,
    height: 28.27,
    transform: "translate(450.42 99.8) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.23,
    y: 302.55,
    width: 38.16,
    height: 28.27,
    transform: "translate(492 141.38) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.96,
    y: 278.94,
    width: 19.59,
    height: 15.24,
    transform: "translate(363.5 573.13) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.54,
    y: 278.94,
    width: 8.27,
    height: 15.24,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.68,
    y: 274.61,
    width: 25.15,
    height: 19.58,
    transform: "translate(416.51 568.79) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.83,
    y: 274.61,
    width: 10.62,
    height: 19.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.23,
    y: 344.13,
    width: 38.16,
    height: 28.27,
    transform: "translate(533.58 182.96) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.64,
    y: 306.63,
    width: 129.62,
    height: 21.93,
    transform: "translate(566.04 69.14) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.22,
    y: 369,
    width: 53.39,
    height: 8.35,
    transform: "translate(391.84 746.34) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.62,
    y: 369,
    width: 10.44,
    height: 8.35,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.59,
    y: 309.22,
    width: 47.44,
    height: 26.54,
    transform: "translate(404.63 644.99) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.04,
    y: 309.22,
    width: 7.02,
    height: 26.54,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-61"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-61",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "279.32 397.83 272.1 395.69 275.12 378.39 282.35 380.52 279.32 397.83",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.06 408.54 334.52 408.54 332.64 391.09 340.18 391.09 342.06 408.54",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.9,407.67h9.19a.64.64,0,0,1,.64.51l1.49,6.7a1.1,1.1,0,0,1-1.1,1.34c-3-.05-5.12-.22-8.84-.22-2.29,0-9.2.24-12.36.24s-3.58-3.13-2.29-3.41c5.81-1.27,10.19-3,12.05-4.7A1.81,1.81,0,0,1,333.9,407.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.39,394.87l7.9,2.34a.66.66,0,0,1,.47.67l-.48,6.85a1.1,1.1,0,0,1-1.42,1c-2.83-.89-6.89-2.28-10.47-3.33-4.19-1.24-7.87-2.08-12.78-3.53-3-.88-2.9-4.12-1.58-4,6,.44,10.68,1.67,16.46.1A3.51,3.51,0,0,1,272.39,394.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.9,178.44c-3.87,2.75-7.75,5.27-11.76,7.73s-8.07,4.77-12.3,6.94l-1.59.81-.44.22-.73.34a12.27,12.27,0,0,1-1.52.5,12,12,0,0,1-5.75,0,20.63,20.63,0,0,1-7.78-4,45.44,45.44,0,0,1-9.87-11.21l4.37-3.59a65.16,65.16,0,0,0,10.4,7.52,13,13,0,0,0,4.73,1.7,1.81,1.81,0,0,0,1.11-.18.39.39,0,0,0,.1-.08l.05-.05.31-.19,1.43-.89c3.8-2.39,7.6-4.88,11.38-7.4l11.36-7.53Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.27,176.19l8.2,17.7C347.76,181.89,336.58,154,303.27,176.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.54,177.09a38.05,38.05,0,0,0-9.93,16.4c7.38-2.56,12.68-5.8,16.16-9.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.34,177.84l-2.67-7.58-6.38,6a8.11,8.11,0,0,0,4.88,4.46Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.35 168.23 266.38 173.74 269.29 176.25 275.67 170.26 271.35 168.23",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.12 378.39 273.56 387.31 280.79 389.45 282.35 380.53 275.12 378.39",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.18 391.09 332.64 391.09 333.61 400.09 341.15 400.09 340.18 391.09",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.32,174.36a4.4,4.4,0,0,1,2.61,5.72,179.8,179.8,0,0,0-6.21,19.9c-1.43,5.71-2.55,11.19-3.45,16.17-2.1,11.68-3,20.67-3.7,23.66L309,232c7.39-58.79,13.05-63.84,13.05-63.84a77.74,77.74,0,0,1,9.7,0q1,.06,2.07.18a147.8,147.8,0,0,1,16.82,3.31c1,.26,2.11.55,3.14.86C355.81,173.14,357.73,173.79,359.32,174.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.14,185.48a31.7,31.7,0,0,0,2.77,17.91c.25-1.13.53-2.26.81-3.4,1.08-4.29,2.34-8.71,3.82-13.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.73,152.43l-12.07,6.78c.23,4.41-.5,8.91-6.82,9.16-1.39,1.6-2.78,5.37,1.78,8.72l-1,3.11c9-.66,14.13-5.57,16-8.51C347.58,167.33,350.6,157.63,352.73,152.43Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,235h0a.25.25,0,0,1-.21-.28c4.33-33.52,12.5-57.5,12.58-57.74a.27.27,0,0,1,.32-.16.26.26,0,0,1,.16.32c-.09.24-8.24,24.18-12.57,57.64A.24.24,0,0,1,323,235Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.75,180a30.21,30.21,0,0,1,5.87-2.91c-1.08-1.15-1.74-6.55-.91-9.05h-2S328.13,169.67,329.75,180Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.61,183.21a9.84,9.84,0,0,0-3.25-4.21c3.25-1,8.81-3.78,10.7-8.72.77.63,2,1.51,2,1.51S354,179.21,342.61,183.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.77,182.59c-.13.62-.54,1.12-.91,1.12s-.58-.51-.46-1.13.53-1.12.91-1.12S336.89,182,336.77,182.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.81,155.2l-7.14,4a17.59,17.59,0,0,1-.07,3.09c2.37.12,6-1.78,6.76-4.15A8.34,8.34,0,0,0,347.81,155.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.62,129.87c-5.16,1.25-7.62,11.82-1.16,15.4C352.07,142.43,355.17,126.34,340.62,129.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.76,143.93c-2.13,7.17-3,11.47-7.55,14.36-6.82,4.34-15-1.07-15.09-8.73-.05-6.9,3.44-17.47,11.23-18.72A10.21,10.21,0,0,1,356.76,143.93Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.19,134c-7.33-1.77-9.53,13.64-3.08,17.22C370,147.85,365.91,135.83,358.19,134Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.42,129.66c-8.05-1.5-13-8-13-8s-6.73,5.2-4.81,9.24,10.94,8.59,15.27,8.76c0,0-2,9.52,6.57,4.16C371.94,136.67,364,131.08,356.42,129.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.21,139.56a9.75,9.75,0,0,1,4.43,5.07C368.27,139,364.37,139.41,363.21,139.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.4,135a16,16,0,0,1-8.82-6.74C336.4,137.51,342.58,135.59,344.4,135Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.82,150.81h0a5.54,5.54,0,0,0,4.93-1.15.2.2,0,0,0,0-.27.19.19,0,0,0-.27,0,5.19,5.19,0,0,1-4.57,1.05.2.2,0,0,0-.09.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.42,151.36a6.46,6.46,0,0,1-4.25,2.07c-2.05.11-2.38-2-1.23-3.79,1-1.64,3.36-3.66,5.14-2.91S358.84,149.83,357.42,151.36Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.34,384.84l12.25,3.62s12.25-41.7,19.86-67.55c2-6.85,5.1-16.49,8.77-26.71,4.63-12.88,10.15-26.74,14.61-37.58,4.69-11.42,8.19-19.48,8.19-19.48L309,232s-21.84,59.7-26.67,82.2C277.33,337.61,271.34,384.84,271.34,384.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.22,294.2c4.63-12.88,10.15-26.74,14.61-37.58l-2-6.21C317.36,257.33,312.6,281,312.22,294.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,234.78s-5.23,64.59-5.25,86.68c0,24.18,12.34,76.89,12.34,76.89h13.81s-5.4-46.64-5.51-70.36c-.12-26.86,10.14-88.17,10.14-88.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.48 398.64 344.74 398.64 344.74 393.79 326.56 393.47 328.48 398.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.49 384.9 284.31 388.99 286.4 384.24 270.65 379.56 270.49 384.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.25,143.41c-.13.59-.56,1-.95.91s-.59-.64-.45-1.23.56-1,.95-.91S345.39,142.82,345.25,143.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.56,141.86c-.14.6-.56,1-.95.91s-.59-.64-.45-1.23.56-1,.94-.91S338.69,141.27,338.56,141.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.62,142.65a21.72,21.72,0,0,1-4,4.41c.82,1.22,2.82,1.06,2.82,1.06Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.83,141.73a.38.38,0,0,1-.31-.21,2.81,2.81,0,0,0-2-1.68.36.36,0,0,1-.29-.41.36.36,0,0,1,.41-.3,3.57,3.57,0,0,1,2.5,2.09.37.37,0,0,1-.18.48A.51.51,0,0,1,347.83,141.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.22,138.89a.44.44,0,0,1-.21-.07.37.37,0,0,1-.05-.51,3.55,3.55,0,0,1,3-1.38.36.36,0,1,1-.07.71h0a2.83,2.83,0,0,0-2.32,1.12A.36.36,0,0,1,336.22,138.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.41,409a2.25,2.25,0,0,1-1.45-.39,1.06,1.06,0,0,1-.37-.94.58.58,0,0,1,.3-.51c.84-.43,3.27,1.07,3.54,1.24a.17.17,0,0,1,.08.18.18.18,0,0,1-.13.15A9.19,9.19,0,0,1,331.41,409Zm-1.12-1.56a.5.5,0,0,0-.23,0,.22.22,0,0,0-.12.21.76.76,0,0,0,.25.65,3.64,3.64,0,0,0,2.67.13A7.18,7.18,0,0,0,330.29,407.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.34,408.72l-.09,0c-.78-.42-2.29-2.08-2.13-2.92a.59.59,0,0,1,.57-.46.93.93,0,0,1,.76.23c.88.71,1.06,2.89,1.07,3a.18.18,0,0,1-.18.19Zm-1.52-3.06h-.08c-.24,0-.26.13-.26.18-.1.5.86,1.74,1.64,2.33a4.34,4.34,0,0,0-.89-2.36A.68.68,0,0,0,331.82,405.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.39,395.66h0c-1.23-.11-3.39-.44-4-1.38a1,1,0,0,1-.08-.92.56.56,0,0,1,.42-.37c1-.22,3.49,2.1,3.77,2.36a.19.19,0,0,1,0,.21A.16.16,0,0,1,271.39,395.66Zm-3.53-2.33h-.05a.22.22,0,0,0-.16.15.65.65,0,0,0,0,.62c.33.52,1.5.94,3.17,1.15C269.87,394.35,268.45,393.27,267.86,393.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.39,395.66a.17.17,0,0,1-.13,0c-.75-.65-2-2.72-1.65-3.5.09-.19.3-.38.78-.29a1.27,1.27,0,0,1,.86.57c.7,1,.32,3,.3,3.12a.16.16,0,0,1-.11.13Zm-1.27-3.5a.22.22,0,0,0-.19.11c-.22.47.59,2,1.32,2.84a4.14,4.14,0,0,0-.29-2.51,1,1,0,0,0-.63-.42A.9.9,0,0,0,270.12,392.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,176.4c.58.58,1,1,1.44,1.49s.87,1,1.29,1.46c.84,1,1.66,2,2.45,3a70.32,70.32,0,0,1,4.39,6.36,60.24,60.24,0,0,1,3.65,6.95,44.45,44.45,0,0,1,2.62,7.62l.24,1,.23,1.17c.1.77.2,1.54.23,2.29a27.1,27.1,0,0,1-.15,4.35,37.58,37.58,0,0,1-1.81,7.86,55,55,0,0,1-7,13.61l-5-2.73,1.08-3.22c.36-1.09.66-2.2,1-3.29a66.84,66.84,0,0,0,1.49-6.55,35.47,35.47,0,0,0,.57-6.27,16.83,16.83,0,0,0-.24-2.82,11.87,11.87,0,0,0-.26-1.27l-.17-.58-.24-.71A50.82,50.82,0,0,0,361,194.77c-1.22-1.82-2.53-3.61-3.9-5.35q-1-1.32-2.1-2.58L354,185.6l-1-1.13Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.81,187.31c2.35,6.63,5.09,11.67,8.95,15.38l14.47-13.79C360,163.07,346.22,177.2,349.81,187.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.55,229.64l-5.65,5.16,8.86,3.76s3.84-5.46,1.17-7.82Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.81 241 365.28 243.76 367.76 238.56 358.9 234.8 357.81 241",
    style: {
      fill: "#ffb573"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--filing-system--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.92,94.84l-58.61,14.4-3.84-8.16a1.64,1.64,0,0,0-1.88-.9l-36.3,8.92a1.65,1.65,0,0,0-1.25,1.67l.38,9L99,125.53a2.55,2.55,0,0,0-1.86,3.08l19.32,78.61a2.54,2.54,0,0,0,3.08,1.87l124.9-30.7a2.55,2.55,0,0,0,1.87-3.08L227,96.7A2.55,2.55,0,0,0,223.92,94.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.92,94.84l-58.61,14.4-3.84-8.16a1.64,1.64,0,0,0-1.88-.9l-36.3,8.92a1.65,1.65,0,0,0-1.25,1.67l.38,9L99,125.53a2.55,2.55,0,0,0-1.86,3.08l19.32,78.61a2.54,2.54,0,0,0,3.08,1.87l124.9-30.7a2.55,2.55,0,0,0,1.87-3.08L227,96.7A2.55,2.55,0,0,0,223.92,94.84Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.11,
    y: 107.51,
    width: 31.08,
    height: 4.13,
    transform: "translate(-22.03 37.21) rotate(-13.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.67,121l-63,15.48-3.84-8.16a1.64,1.64,0,0,0-1.88-.9l-36.3,8.92A1.64,1.64,0,0,0,119.4,138l.38,9-19,4.67a2.55,2.55,0,0,0-1.87,3.08l19.32,78.61a2.55,2.55,0,0,0,3.08,1.87l124.91-30.7a2.54,2.54,0,0,0,1.86-3.08l-19.31-78.61A2.55,2.55,0,0,0,225.67,121Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.67,121l-63,15.48-3.84-8.16a1.64,1.64,0,0,0-1.88-.9l-36.3,8.92A1.64,1.64,0,0,0,119.4,138l.38,9-19,4.67a2.55,2.55,0,0,0-1.87,3.08l19.32,78.61a2.55,2.55,0,0,0,3.08,1.87l124.91-30.7a2.54,2.54,0,0,0,1.86-3.08l-19.31-78.61A2.55,2.55,0,0,0,225.67,121Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.47,
    y: 134.71,
    width: 31.08,
    height: 4.13,
    transform: "translate(-28.6 37.37) rotate(-13.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.43,147.08,160,163.64l-3.84-8.16a1.64,1.64,0,0,0-1.88-.9L118,163.5a1.64,1.64,0,0,0-1.25,1.67l.38,9-14.61,3.59a2.55,2.55,0,0,0-1.87,3.08L120,259.46a2.55,2.55,0,0,0,3.08,1.87L248,230.63a2.54,2.54,0,0,0,1.87-3.08l-19.32-78.61A2.53,2.53,0,0,0,227.43,147.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.43,147.08,160,163.64l-3.84-8.16a1.64,1.64,0,0,0-1.88-.9L118,163.5a1.64,1.64,0,0,0-1.25,1.67l.38,9-14.61,3.59a2.55,2.55,0,0,0-1.87,3.08L120,259.46a2.55,2.55,0,0,0,3.08,1.87L248,230.63a2.54,2.54,0,0,0,1.87-3.08l-19.32-78.61A2.53,2.53,0,0,0,227.43,147.08Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.83,
    y: 161.91,
    width: 31.08,
    height: 4.13,
    transform: "translate(-35.16 37.52) rotate(-13.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.59,175.25,203.76,179l-2.23-8.74a1.65,1.65,0,0,0-1.68-1.24l-37.33,1.9a1.65,1.65,0,0,0-1.55,1.4l-1.33,8.92-10.5.54a2.54,2.54,0,0,0-2.42,2.67l4.12,80.84a2.55,2.55,0,0,0,2.67,2.42L282,261.18a2.55,2.55,0,0,0,2.42-2.67l-4.12-80.85A2.54,2.54,0,0,0,277.59,175.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.59,175.25,203.76,179l-2.23-8.74a1.65,1.65,0,0,0-1.68-1.24l-37.33,1.9a1.65,1.65,0,0,0-1.55,1.4l-1.33,8.92-10.5.54a2.54,2.54,0,0,0-2.42,2.67l4.12,80.84a2.55,2.55,0,0,0,2.67,2.42L282,261.18a2.55,2.55,0,0,0,2.42-2.67l-4.12-80.85A2.54,2.54,0,0,0,277.59,175.25Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.9,
    y: 172.99,
    width: 31.08,
    height: 4.13,
    transform: "translate(-8.66 9.45) rotate(-2.91)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.94,199.31,154.75,218l-3.83-8.16A1.66,1.66,0,0,0,149,209l-36.3,8.92a1.64,1.64,0,0,0-1.25,1.67l.38,9L106,230a2.55,2.55,0,0,0-1.87,3.08l19.32,78.61a2.56,2.56,0,0,0,3.09,1.87l124.9-30.7a2.55,2.55,0,0,0,1.86-3.08L234,201.18A2.56,2.56,0,0,0,230.94,199.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.94,199.31,154.75,218l-3.83-8.16A1.66,1.66,0,0,0,149,209l-36.3,8.92a1.64,1.64,0,0,0-1.25,1.67l.38,9L106,230a2.55,2.55,0,0,0-1.87,3.08l19.32,78.61a2.56,2.56,0,0,0,3.09,1.87l124.9-30.7a2.55,2.55,0,0,0,1.86-3.08L234,201.18A2.56,2.56,0,0,0,230.94,199.31Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.55,
    y: 216.31,
    width: 31.08,
    height: 4.13,
    transform: "translate(-48.3 37.84) rotate(-13.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.66,
    y: 239.54,
    width: 133.71,
    height: 86.04,
    rx: 2.55,
    transform: "translate(-62.22 51.25) rotate(-13.81)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.12,247.76l-39.85,9.79a1.65,1.65,0,0,1-2-1.53l-.39-9.25a1.64,1.64,0,0,1,1.25-1.67l36.3-8.92a1.66,1.66,0,0,1,1.89.9l3.94,8.37A1.66,1.66,0,0,1,151.12,247.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 243.51,
    width: 31.08,
    height: 4.13,
    transform: "translate(-54.87 37.99) rotate(-13.81)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyregistration);
export default __webpack_public_path__ + "static/media/companyregistration.09d3c1bc09c7bef2fbe23148f26034c4.svg";
export { ForwardRef as ReactComponent };